import(/* webpackMode: "eager" */ "/vercel/path0/src/app/telegram/page.jsx");
